import { render } from "./suggestWrite.vue?vue&type=template&id=6eafd0ba&scoped=true&ts=true"
import script from "./suggestWrite.vue?vue&type=script&lang=ts&config=true"
export * from "./suggestWrite.vue?vue&type=script&lang=ts&config=true"

import "./suggestWrite.vue?vue&type=style&index=0&id=6eafd0ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eafd0ba"]])

export default __exports__